module.exports = __webpack_public_path__ + "gameconsole-fb6c841c.webp";